module.exports = __webpack_public_path__ + "img/404.ab7db449.png";